var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCausesIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_756_3808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_756_3808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.5C4.08333 19.5 3.72933 19.354 3.438 19.062C3.146 18.7707 3 18.4167 3 18V14.4C3.56667 14.3 4.04167 14.025 4.425 13.575C4.80833 13.125 5 12.6 5 12C5 11.4 4.80833 10.875 4.425 10.425C4.04167 9.975 3.56667 9.7 3 9.6V6C3 5.58333 3.146 5.22933 3.438 4.938C3.72933 4.646 4.08333 4.5 4.5 4.5H20.5C20.9167 4.5 21.2707 4.646 21.562 4.938C21.854 5.22933 22 5.58333 22 6V9.6C21.4333 9.7 20.9583 9.975 20.575 10.425C20.1917 10.875 20 11.4 20 12C20 12.6 20.1917 13.125 20.575 13.575C20.9583 14.025 21.4333 14.3 22 14.4V18C22 18.4167 21.854 18.7707 21.562 19.062C21.2707 19.354 20.9167 19.5 20.5 19.5H4.5ZM4.5 18H20.5V15.45C19.8833 15.0833 19.396 14.596 19.038 13.988C18.6793 13.3793 18.5 12.7167 18.5 12C18.5 11.2833 18.6793 10.6207 19.038 10.012C19.396 9.404 19.8833 8.91667 20.5 8.55V6H4.5V8.55C5.11667 8.91667 5.60433 9.404 5.963 10.012C6.321 10.6207 6.5 11.2833 6.5 12C6.5 12.7167 6.321 13.3793 5.963 13.988C5.60433 14.596 5.11667 15.0833 4.5 15.45V18ZM12.5 16.65C12.7167 16.65 12.896 16.5793 13.038 16.438C13.1793 16.296 13.25 16.1167 13.25 15.9C13.25 15.6833 13.1793 15.5043 13.038 15.363C12.896 15.221 12.7167 15.15 12.5 15.15C12.2833 15.15 12.1043 15.221 11.963 15.363C11.821 15.5043 11.75 15.6833 11.75 15.9C11.75 16.1167 11.821 16.296 11.963 16.438C12.1043 16.5793 12.2833 16.65 12.5 16.65ZM12.5 12.75C12.7167 12.75 12.896 12.679 13.038 12.537C13.1793 12.3957 13.25 12.2167 13.25 12C13.25 11.7833 13.1793 11.604 13.038 11.462C12.896 11.3207 12.7167 11.25 12.5 11.25C12.2833 11.25 12.1043 11.3207 11.963 11.462C11.821 11.604 11.75 11.7833 11.75 12C11.75 12.2167 11.821 12.3957 11.963 12.537C12.1043 12.679 12.2833 12.75 12.5 12.75ZM12.5 8.85C12.7167 8.85 12.896 8.779 13.038 8.637C13.1793 8.49567 13.25 8.31667 13.25 8.1C13.25 7.88333 13.1793 7.704 13.038 7.562C12.896 7.42067 12.7167 7.35 12.5 7.35C12.2833 7.35 12.1043 7.42067 11.963 7.562C11.821 7.704 11.75 7.88333 11.75 8.1C11.75 8.31667 11.821 8.49567 11.963 8.637C12.1043 8.779 12.2833 8.85 12.5 8.85Z",
    fill: "#00DA93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCausesIconOn);
export default __webpack_public_path__ + "static/media/causesIconOn.14de5e5e376541494750d1f8a74022fe.svg";
export { ForwardRef as ReactComponent };